module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(("返回[" + (this.$route.query.username) + "歌单-" + (this.$route.query.title) + "]")))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "歌曲名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetch
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordList,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "priority",
      "label": "排序",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryId",
      "label": "分类",
      "width": "100",
      "formatter": _vm.formatCategory
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "singerName",
      "label": "歌手",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileName",
      "label": "文件",
      "width": "220"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "buttonText",
          attrs: {
            "href": scope.row.url,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fileSize",
      "label": "大小",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "创建时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "250",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage,
      "page-count": _vm.pageNo,
      "total": _vm.pageTotal
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.editFormVisible),
      callback: function($$v) {
        _vm.editFormVisible = $$v
      },
      expression: "editFormVisible"
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.editFormRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.albumId),
      expression: "editForm.albumId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.editForm.albumId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "albumId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.userId),
      expression: "editForm.userId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.editForm.userId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.editForm, "userId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.singerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件名",
      "prop": "fileName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.editForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先级",
      "prop": "priority"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "999",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "priority", $$v)
      },
      expression: "editForm.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addFormVisible),
      callback: function($$v) {
        _vm.addFormVisible = $$v
      },
      expression: "addFormVisible"
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.addFormRules
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.albumId),
      expression: "addForm.albumId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.addForm.albumId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "albumId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addForm.userId),
      expression: "addForm.userId"
    }],
    attrs: {
      "hidden": ""
    },
    domProps: {
      "value": (_vm.addForm.userId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addForm, "userId", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌曲名",
      "prop": "name"
    }
  }, [_c('el-autocomplete', {
    staticClass: "el-input",
    attrs: {
      "fetch-suggestions": _vm.searchMusic,
      "placeholder": "搜索歌曲名",
      "trigger-on-focus": false
    },
    on: {
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "歌手",
      "prop": "singerName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.singerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件名",
      "prop": "fileName"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文件大小",
      "prop": "fileSize"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.addForm.fileSize))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优先级",
      "prop": "priority"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "999",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.priority),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "priority", $$v)
      },
      expression: "addForm.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c4cbd0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AlbumMusic.vue
// module id = 575
// module chunks = 1